import checkRealtimeSocketConnection from '../../../actions/CheckRealtimeSocketConnection';
import { StudioLogger } from '@studio/logger/StudioLogger';
const LOG = new StudioLogger('SocketDispatcher');

/**
 * Sets up the socket 'connect' event handler.
 * When the socket connects, it clears any pending timeout for connection loss,
 * dispatches a realtime connection check, and logs the connection event.
 *
 * @param {Object} socket - The socket.io socket instance
 * @param {Object} store - The Redux store instance
 * @returns {void}
 */
const socketConnected = (socket, store) => {
  socket.on('connect', () => {
    clearTimeout(globalThis.realtimeConnectionLostTimeout);
    globalThis.realtimeConnectionLostTimeout = null;
    store.dispatch(checkRealtimeSocketConnection());
  });

  const {
    meeting: { attendeeResponse }
  } = store.getState();
  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };
  LOG.info('Realtime socket connected', payload);
};

export { socketConnected };
